'use client';

import React, { useState } from 'react';
import AppImage from '@/components/common/AppImage';
import styles from './styles.module.css';
// import GeneralIcons from "@/icons";
import Link from 'next/link';
import MainIcons from '@/icons/main';
import { UploadedItem } from '@/commonTypes';

/* ---------- Types ---------- */

interface UploadedGalleryItemsProps {
  images?: UploadedItem[];
  callBackDeleteItem?: (item: UploadedItem) => void | null;
  singleGalleryClassName?: string;
  className?: string;
}

/* ---------- Component ---------- */

export default function UploadedGalleryItems({
  images,
  callBackDeleteItem,
  singleGalleryClassName,
  className = '',
}: UploadedGalleryItemsProps) {
  const [chosen, setChosen] = useState<UploadedItem | null>(null);

  return (
    <div className={`${styles.container} ${className}`}>
      {images?.map((item, index) => (
        <Link
          key={index}
          href={!item?.url?.startsWith('http') ? `${process.env.IMAGE_URL}${item?.url}` : item?.url}
          target="_blank"
          className={`${styles.singleItem} ${singleGalleryClassName}`}
          onMouseEnter={() => setChosen(item)}
          onMouseLeave={() => setChosen(null)}
        >
          <AppImage className={styles.image} src={item?.url} width={100} height={100} />
          {chosen?.url === item.url && (
            <div className={styles.absoluteBox}>
              {callBackDeleteItem && (
                <MainIcons.deleteIcon
                  width="24px"
                  height="24px"
                  fill="#fff"
                  className="cursor-pointer"
                  onClick={(e: Event) => {
                    e.preventDefault();
                    e.stopPropagation();
                    callBackDeleteItem(item);
                  }}
                />
              )}
            </div>
          )}
        </Link>
      ))}
    </div>
  );
}
